// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/core-js/modules/es7.map.of.js
// module id = 681
// module chunks = 8